import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    @import url('https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap');
    * {
        font-family: 'Work Sans', sans-serif;
    }
    html, body {
        overflow-x: hidden;
        scroll-behavior: auto !important;
    }
`;

